var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "menu icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "menu-icon",
    fillRule: "nonzero",
    fill: "#9DA2A6"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.000000, 3.000000)",
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.71463476,5.5537033 L14.3163039,1.46333077 L13.2937107,1.46333077 L8.69204162,5.5537033 L12.2711176,0.44073764 L11.2485245,0.44073764 L7.66944849,5.5537033 L3.71150177,5.5537033 L0,5.5537033 L0,9.13277926 C0,10.7264907 1.08088094,12.0763136 2.57386691,12.539037 C2.56466358,12.5957909 2.55648283,12.6525448 2.55648283,12.7113439 C2.55648283,13.2758153 3.01460455,13.7339371 3.57907596,13.7339371 L10.7372279,13.7339371 C11.3016993,13.7339371 11.759821,13.2758153 11.759821,12.7113439 C11.759821,12.6525448 11.7516403,12.5947683 11.7424369,12.5385257 C13.2359342,12.0758023 14.3163039,10.7264907 14.3163039,9.13226797 L14.3163039,5.553192 L10.6042908,5.553192 L9.71463476,5.553192 L9.71463476,5.5537033 Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/Menu.b2ff78857ed8b0326d36d32d80b6a35b.svg";
export { ForwardRef as ReactComponent };